import { CerFormAdapter } from '@cer/cer-form/cer-form-adapter';
import { CerFormView } from '@cer/cer-form/cer-form-view';

export class SalesOrderTypeForm extends CerFormAdapter {

  override view(): CerFormView {
    return new CerFormView({
      viewMetadata: {
        name: 'salg-ordretyper', dataApiName: 'SalesOrderType', text: 'Salg ordretyper',
        primaryKey: 'num', baseFields: ['id', 'num', 'name', 'history']
      }, 
      fieldMetadata: []
    });

  }
}
